<template src="./template.html" />

<script>
export default {
  props: {
    title: String,
    active: Boolean
  }
}
</script>

<style scoped src="./style.scss" lang="scss"/>
